import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('@/views/index'),
        meta: {title: '首页'}
    },
    {
        path: '/allPersons',
        component: () => import('@/views/allPersons'),
        meta: {title: '首页', Auth: true}
    },
    {
        path: '/relation/:id',
        component: () => import('@/views/relation'),
        meta: {title: '关系图谱', Auth: true}
    }, {
        path: '/login',
        component: () => import('@/views/login'),
        meta: {title: '登录'}
    },
    {
        path: '/404',
        component: () => import('@/views/404'),
        meta:{title:'404'}
    },
    { path: '*', redirect: '/404' }
]

const router = new VueRouter({
    routes
})

export default router
